<template>
    <div>
        <Modal
            class-name="vertical-center-modal"
            :value="showModel"
            :title="title"
            :footer-hide="true"
            :mask-closable="false"
            @on-cancel="cancel"
            @on-visible-whetherSync="openOrClose"  :styles="{'min-width':'550px'}">
            
            <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
                <FormItem label="Word_ID" prop="wordCode" style="width: 500px">
                    <Input type="text"  v-model.trim="formData.wordCode" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_zh')" prop="simpleChinese" style="width: 500px">
                    <Input type="textarea"  v-model="formData.simpleChinese" :title="formData.simpleChinese" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_zh_ft')" prop="traditionalChinese" style="width: 500px">
                    <Input type="textarea"  v-model="formData.traditionalChinese" :title="formData.traditionalChinese" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_en')" prop="englishText" style="width: 500px">
                    <Input type="textarea"  v-model="formData.englishText" :title="formData.englishText" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_fr')" prop="frenchText" style="width: 500px">
                    <Input type="textarea"  v-model="formData.frenchText" :title="formData.frenchText" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_de')" prop="germanText" style="width: 500px">
                    <Input type="textarea"  v-model="formData.germanText" :title="formData.germanText" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_es')" prop="spanishText" style="width: 500px">
                    <Input type="textarea"  v-model="formData.spanishText" :title="formData.spanishText" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem :label="$t('editMesageModule.lang_ja')" prop="japanText" style="width: 500px">
                    <Input type="textarea"  v-model="formData.japanText" :title="formData.japanText" :placeholder="$t('inputPlaceholder')" ></Input>
                </FormItem>
                <FormItem v-if='roleType==1 && showChildrenSide' class="changeBox" label="" prop="">
                    <Checkbox v-model="formData.whetherSync">{{$t('productPage.mulLang.whetherSync')}}</Checkbox>
                </FormItem>
            </Form>
    
            <div class="flexCC">
              <Button :loading="disabled"  type="primary" @click="subData('formData')" style="marginRight:20px">{{$t('save')}}</Button>
              <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </div>
    
        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import { mapState } from 'vuex'

export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            roleType:Number
        },
        name: "Modelnew",
        components: {
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    wordCode:'',//页面编号
                    simpleChinese:'',
                    traditionalChinese:'',
                    englishText:'',
                    frenchText:'',
                    germanText:'',
                    spanishText:'',
                    japanText:'',
                    whetherSync:true
                }
            }
        },

        computed:{
             ...mapState(['selectId','showChildrenSide']),
            ruleCustom(){
                return {
                    wordCode: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^\w+$/, message: this.$t('ruleCustom.wordCode'), trigger:'blur'},
                    ],
                    simpleChinese: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        // {type: 'string', pattern: /(^ +)|(\S)/, message: this.$t('ruleCustom.blankCode'), trigger:'blur'},
                    ],
                    traditionalChinese: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    englishText: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    frenchText: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    germanText: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    spanishText: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    japanText: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                }
            }

        },
        created(){
        },
        mounted(){
        },
        watch:{
            showModel(val){
                if(val==true){
                    // console.log('this.editFormData',this.editFormData)
                    if(this.type == 2){//编辑表单时，给表单赋值

                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }

                        if(this.roleType==1){
                            // this.formData.whetherSync = this.editFormData.whetherSync
                            this.formData.whetherSync = true
                        }
                        
                        this.formData.wordCode= this.editFormData.wordCode+'';
                    
                    }

                    this.title = this.type == 1?this.$t('productPage.mulLang.addTitle'):this.$t('productPage.mulLang.editTitle')
                }else{
                    this.resetForm();//重置表单
                }
 
            },
        },
        methods: {
            
            openOrClose(value) {
                if(value === false) {
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                // console.log(this.formData)
                this.$refs[name].validate((valid) => {
                    if (valid) {

                        this.disabled = true;

                        let url = ''
                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                            url = this.config.urlArray.editOneWordCode
                        }else{
                            url =  this.config.urlArray.addOneWordCode
                        }    
                        
                        if(this.roleType!=1 || !this.showChildrenSide){
                            delete this.formData.whetherSync
                        }
                        
                        
                        this.axios.post(url, {...this.formData,pageId:this.editFormData.pageId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{
                                this.disabled = false;
                            })
                            
                            
                        }).catch((err) => {
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm();//重置表单
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.whetherSync = true
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
}
</script>
<style lang='less' scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}

.changeBox{
    /deep/ .ivu-form-item-content{
         margin-left: 0 !important;
         text-align: center;

    }
   
}


</style>
